import React, { forwardRef, HTMLProps, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Panel.module.scss';

export const Panel = forwardRef<HTMLDivElement, Props>(({
    children, className, ...rest
}, ref) => {
    return (
        <div ref={ref} className={classNames(styles.default, className)} {...rest}>
            {children}
        </div>
    );
});

type Props = HTMLProps<HTMLDivElement> & PropsWithChildren<{
    className?: string;
}>;